export default __webpack_public_path__ + "static/media/visa-logo_48x15.af57ea5d.svg";